import * as Immutable from 'seamless-immutable';
import {
  ACTIVITIES_FETCH_API_REJECTED,
  ACTIVITIES_FETCH_API_SET_BLOCKS,
  ACTIVITIES_FETCH_START,
  ACTIVITIES_SET_DUMMY_BLOCK,
  ATTACHMENT_DELETE_API_FULFILLED
} from '../actions';

const initialState = Immutable.from({
  offset: 0,
  blocks: [],
  issueId: null,
  isFetching: false,
  dummyBlock: null,
  hasError: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIVITIES_FETCH_START: {
      const {issueId} = action.payload;
      const issueIdChanged = state.issueId !== issueId;
      const blocks = issueIdChanged ? [] : state.blocks;
      return state.merge({
        blocks,
        issueId,
        isFetching: true,
        dummyBlock: issueIdChanged ? null : state.dummyBlock,
        hasError: false
      });
    }
    case ACTIVITIES_FETCH_API_SET_BLOCKS: {
      const {blocks, total, offset} = action.payload;
      return state.merge({
        blocks,
        total,
        offset,
        isFetching: false,
        dummyBlock: null
      });
    }
    case ACTIVITIES_FETCH_API_REJECTED:
      return state.merge({
        isFetching: false,
        hasError: true
      });
    case ATTACHMENT_DELETE_API_FULFILLED:
      return state.merge({
        blocks: [],
        offset: 0
      });
    case ACTIVITIES_SET_DUMMY_BLOCK:
      return state.set('dummyBlock', action.payload);
    default:
      return state;
  }
};
